import { cn } from '@/shared/lib/cn';
import { type VariantProps, cva } from 'class-variance-authority';
import type * as React from 'react';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-red-200 dark:border-red-900 bg-red-50 dark:bg-red-950 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900',
        outline:
          'border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300',
        warning:
          'border-orange-200 dark:border-orange-900 bg-orange-50 dark:bg-orange-950 text-orange-700 dark:text-orange-300 hover:bg-orange-100 dark:hover:bg-orange-900',
        allocated:
          'border-transparent bg-blue-100 dark:bg-blue-950 text-blue-700 dark:text-blue-300',
        progress:
          'border-transparent bg-yellow-100 dark:bg-yellow-950 text-yellow-700 dark:text-yellow-300',
        pending: 'border-transparent bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300',
        success:
          'border-transparent bg-green-100 dark:bg-green-950 text-green-700 dark:text-green-300',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
